<template>
  <slideout-panel :is-full-width="true" v-on:slideout:close="closePanel" :open="updateTemplatePanelIsOpen" title="Update Template">
    <div class="pb-5">
      <div
          v-if="errors.length > 0"
          class="errors">
        <div
            v-for="error in errors"
            class="text-red">
          {{ error }}
        </div>
      </div>
      <form>
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">Name</label>
          <div class="mt-1 relative rounded-md shadow-sm">

            <input
                v-if="storeTemplate"
                v-model="storeTemplate.name"
                type="text"
                name="email"
                id="email"
                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-3 sm:text-sm border-gray-300
                        rounded-md"

                placeholder="Template Name" />
            <div
                v-for="error in v$.storeTemplate.name.$silentErrors"
                :key="error.$uid"
                class="error-msg mt-1 ml-5 text-red-500 font-bold">
              <small>
                {{ error.$message }}
              </small>
            </div>
            <div class="mt-5">
              <label for="email" class="block text-sm font-medium text-gray-700">Subject</label>

              <input
                  v-if="storeTemplate"
                  v-model="storeTemplate.subject"
                  type="text"
                  name="email"
                  id="subject"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-3 sm:text-sm border-gray-300
                          rounded-md"
                  placeholder="Template Subject" />
              <div
                  v-for="error in v$.storeTemplate.subject.$silentErrors"
                  :key="error.$uid"
                  class="error-msg mt-1 ml-5 text-red-500 font-bold">
                <small>
                  {{ error.$message }}
                </small>
              </div>
            </div>
            <div id="quill-template" class="mt-5">
              <quill @update:quillBody="setBody" :quillBody="storeTemplate.body" />
            </div>
          </div>
        </div>
        <div v-if="!showVars" @click="showVars = !showVars" class="mt-3 text-gray-500 text-sm">
          <span>View available parameters.</span>
        </div>
        <div v-if="showVars" @click="showVars = !showVars" class="mt-3">
          <pre>{{ storeTemplate.sampleRow }}</pre>
        </div>
        <div class="mt-3">
          <primary-button class="mr-2" @click="handlePreviewTemplate" text="Preview" />
          <primary-button :disabled="!previewed" class="mr-2" @click="handleUpdateTemplate" text="Update Template" />
        </div>
      </form>
      <div class="mt-5">
        <h1 class="text-xl">
          Preview
        </h1>
        <div class="p-2 border border-black">
          <email-preview :preview-content="previewTemplate" />
        </div>
      </div>
    </div>
  </slideout-panel>
</template>

<script>
import SlideoutPanel from "@/components/Functional/SlideoutPanel";
import {PencilIcon} from "@heroicons/vue/solid/esm";
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators"
import EmailPreview from "@/components/Functional/EmailPreview/EmailPreview";
import Quill from "@/components/Functional/Quill/Quill";

function initialState() {
  return {
      template:{},
      previewTemplate: "Click preview to test",
      previewed: false,
      showVars: false,
      sampleRow: null,
      errors: [],
  }
}
export default {
  name: "UpdateTemplatePanel",
  components: {
    EmailPreview,
    SlideoutPanel,
    PencilIcon,
    PrimaryButton,
    Quill,
  },
  props: ['templateId'],

  setup() {
    return {
      v$: useVuelidate()
    }
  },

  data() {
    return initialState()
  },
  methods: {
    setBody(body) {
      this.storeTemplate.body = body
    },
    closePanel() {
      this.$store.dispatch('closeUpdateTemplatePanel')
      Object.assign(this.$data, initialState())
    },
    async handlePreviewTemplate() {
      this.$store.dispatch('showLoadingSpinner')

      this.errors = []
      try {
        await this.$store.dispatch('previewTemplate', this.storeTemplate)
        this.previewTemplate = this.$store.getters.getPreviewTemplate.body
        this.previewed = true
      } catch (e) {
        console.log(e.response)
        this.errors = e.response.data.errors
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('hideLoadingSpinner')

    },
    async handleUpdateTemplate() {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('updateTemplate', this.storeTemplate)

        Object.assign(this.$data, initialState())

        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Template Successfully Updated'
        })

      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('closeUpdateTemplatePanel')
      this.$store.dispatch('hideLoadingSpinner')

    },
    handleBodyUpdate(body) {
      this.previewed = false
      this.template.body = body
    },
  },
  computed: {
    updateTemplatePanelIsOpen() {
      return this.$store.getters.getUpdateTemplatePanelIsOpen
    },
    storeTemplate() {
      const temp = this.$store.getters.getTemplate
      this.template = temp

      return temp
    },
  },
  validations: {
    storeTemplate: {
      name: { required },
      subject: { required },
    }
  },
}
</script>

<style lang="scss" scoped>


</style>
